import React, { useState } from "react";
import Sidebar from "../../../components/Sidebar";
import InPlay from "../../../components/InPlay";
import Header from "./../../../components/Header/Header";
import Navbar from "./../../../components/Header/Navbar";
import BetSlip from "../../../components/BetSlip";
import { useGetCricketMatchesQuery } from "../../../../store/services/mainApi";
import Loader from "../../../components/Loader";
import Error from "../../../components/Error";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { handelActiveMatch } from "../../../../store/features/eventSlice";
import MobFooter from "../../../components/MobFooter";
import MobSlider from "../../../components/MobSlider";

const CricketPage = ({
  activeName,
  cricketMatch,
  soccerMatch,
  tennisMatch,
  activeApi,
}) => {
  const dispatch = useDispatch();
  soccerMatch = soccerMatch;
  tennisMatch = tennisMatch;
  // const dispatch = useDispatch();
  // const { data, isFetching, error } = useGetCricketMatchesQuery();
  // console.log(data);
  // if (isFetching) {
  //   return <Loader />;
  // }
  // if (error) {
  //   return <Error />;
  // }
  // let data = [];
  // activeApi?.map((ele) => {
  //   if (ele.active && ele.title === "InPlay") {
  //     data = [cricketMatch, soccerMatch, tennisMatch];
  //     let mergedArray = cricketMatch.concat(soccerMatch);
  //     let allMerged = mergedArray.concat(tennisMatch);
  //     data = allMerged.filter((ele) => {
  //       return ele?.inPlay === "True" || ele?.inPlay;
  //     });
  //   } else if (ele.active && ele.title === "Cricket") {
  //     data = cricketMatch;
  //   } else if (ele.active && ele.title === "Soccer") {
  //     data = soccerMatch;
  //   } else if (ele.active && ele.title === "Tennis") {
  //     data = tennisMatch;
  //   }
  // });
  // console.log(cricketMatch);

  const [activeLink, setActiveLink] = useState(1);

  const changeColor = (index) => {
    setActiveLink(index);
  };

  return (
    <div>
      <Header />
      <Navbar />
      <div className="mt-1">
        <div className="sidebar flex ">
          <Sidebar />
          <div className="detail_page mx-1 w-[60%]">
            <div className="bg-[#566772]  p-[15px] hide_part_mobile"></div>
            <img
              src="https://www.sabaexch.com/assets/images/kv_tennis.jpg"
              className="w-[100%] hide_part_mobile h-[200px]"
              alt=""
            />
            <MobSlider />

            <div className="flex justify-between mt-3 px-5 hide_part_mobile bg-[#67f0c2]">
              <h2 className="text-sm font-semibold ">Sports Highlights</h2>
              <span>View by</span>
            </div>
            <div className="mob_navbar hide_part_desktop  px-3 gap-[15px] flex justify-start items-center h-[50px] ">
              <div>
                <img
                  src="data:image/gif;base64,R0lGODdhAQABAIAAAAAAAP///yH5BAEAAAEALAAAAAABAAEAAAICTAEAOw=="
                  alt=""
                />
                <Link
                  to={"/cricket"}
                  className={`px-2 py-1 rounded-lg flex ${
                    activeLink === 1 ? "change_color" : "Before_change_color"
                  }`}
                  onClick={() => changeColor(1)}
                >
                  <div className="live_headtitle top-[0px]">
                    <div className="bg-white h-full flex items-center justify-center w-[20px]">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="14"
                        height="8"
                      >
                        <g
                          fill={
                            activeLink === 1 ? "rgb(255,0,0)" : "rgb(0,0,0)"
                          }
                          fillRule="evenodd"
                        >
                          <path d="M12.012 0l-.698.727c1.734 1.808 1.734 4.738 0 6.546l.698.727c2.117-2.207 2.117-5.79 0-8zM10.3 1.714l-.7.735c.967 1.014.967 2.66 0 3.673l.7.735c1.352-1.418 1.352-3.721 0-5.143zM1.588 0l.698.727c-1.734 1.808-1.734 4.738 0 6.546L1.588 8c-2.117-2.207-2.117-5.79 0-8zM3.3 1.714l.7.735c-.967 1.014-.967 2.66 0 3.673l-.7.735c-1.352-1.418-1.352-3.721 0-5.143z" />
                          <circle cx="6.8" cy="4.4" r="1.6" />
                        </g>
                      </svg>
                    </div>

                    <span className="text-[11px]">11</span>
                  </div>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="25"
                    height="25"
                    className={`mr-1 ${
                      activeLink === 1
                        ? "fill-current text-yellow-500"
                        : "fill-current text-black"
                    }`}
                  >
                    <path
                      fillRule="evenodd"
                      fill={activeLink === 1 ? "#ffb200" : "#000000"}
                      d="M4.565 2.84c.505-.414 1.042-.79 1.608-1.123l15.66 19.1c-.436.487-.91.94-1.416 1.356L4.565 2.84zm-1.79 1.806 15.522 18.93A12.416 12.416 0 0 1 12.5 25C5.596 25 0 19.404 0 12.5c0-2.975 1.04-5.707 2.775-7.854zM8.557.636A12.424 12.424 0 0 1 12.5 0C19.404 0 25 5.596 25 12.5c0 2.252-.596 4.366-1.638 6.19L8.557.636z"
                    />
                  </svg>
                  Cricket
                </Link>
              </div>
              <div>
                <img
                  src="data:image/gif;base64,R0lGODdhAQABAIAAAAAAAP///yH5BAEAAAEALAAAAAABAAEAAAICTAEAOw=="
                  alt=""
                />
                <Link
                  to={"/soccer"}
                  className={`px-2 py-1 rounded-lg flex ${
                    activeLink === 2 ? "change_color" : "Before_change_color"
                  }`}
                  onClick={() => changeColor(2)}
                  // className="bg-black px-[5px] py-[10px] rounded-[5px] text-[#ffb200] flex"
                >
                  <div className="live_headtitle top-[0px]">
                    <div className="bg-white h-full flex items-center justify-center w-[20px]">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="14"
                        height="8"
                      >
                        <g fill="rgb(255,0,0)" fill-rule="evenodd">
                          <path d="M12.012 0l-.698.727c1.734 1.808 1.734 4.738 0 6.546l.698.727c2.117-2.207 2.117-5.79 0-8zM10.3 1.714l-.7.735c.967 1.014.967 2.66 0 3.673l.7.735c1.352-1.418 1.352-3.721 0-5.143zM1.588 0l.698.727c-1.734 1.808-1.734 4.738 0 6.546L1.588 8c-2.117-2.207-2.117-5.79 0-8zM3.3 1.714l.7.735c-.967 1.014-.967 2.66 0 3.673l-.7.735c-1.352-1.418-1.352-3.721 0-5.143z" />
                          <circle cx="6.8" cy="4.4" r="1.6" />
                        </g>
                      </svg>
                    </div>

                    <span className=" text-[11px]  ">11</span>
                  </div>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="25"
                    height="25"
                    className="bg-[#ffb200] rounded-[50%] mr-1"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M19.63 2.945a12.021 12.021 0 0 0-2.492-1.43 12.06 12.06 0 0 0-1.495-.516c-.4.162-.892.472-1.714 1.174a10.358 10.358 0 0 0-2.076-.01c-.91.086-1.822.288-2.715.604-.808.283-1.446.606-1.876.853-.626-.223-1.49-.496-1.937-.64-.44.333-.86.697-1.256 1.093a11.906 11.906 0 0 0-2.428 3.5c-.074.785-.037 1.595.018 2.21a10.608 10.608 0 0 0-.628 2.3c-.128.827-.18 2.328-.12 3.223a11.886 11.886 0 0 0 4.109 6.478c-.013-.275-.096-1.328-.09-1.727l4.106-1.37 4.74 2.05c.367 1.485.56 2.295.583 2.43-.87.57-3.007.998-4 1.063.7.126 1.415.19 2.14.19a11.862 11.862 0 0 0 6.86-2.168c-.878.453-1.912.55-2.89.71-.086.012-1.312.1-1.32.063l-.617-2.51 3.337-3.474 4.324-.394c.065.673.273 1.665.337 2.3a11.873 11.873 0 0 0 1.89-6.445c0-1.14-.16-2.26-.474-3.338-.002.01-.002.016-.002.023-.26-.502-.564-.985-.908-1.444a11.3 11.3 0 0 0-1.923-1.992c-.133-.664-.5-1.707-1.484-2.803zm1.707.715a12.513 12.513 0 0 1 2.68 3.976c.652 1.54.983 3.18.983 4.865 0 1.69-.33 3.326-.982 4.867a12.418 12.418 0 0 1-2.68 3.973 12.446 12.446 0 0 1-8.838 3.66c-1.69 0-3.325-.33-4.866-.982a12.434 12.434 0 0 1-3.973-2.678A12.472 12.472 0 0 1 0 12.5c0-1.687.33-3.323.982-4.864.63-1.49 1.53-2.826 2.68-3.973A12.414 12.414 0 0 1 7.633.985 12.415 12.415 0 0 1 12.497 0c1.69 0 3.325.33 4.866.982a12.45 12.45 0 0 1 3.974 2.678zm-4.37 2.287-2.138 5.835-5.13.985L5.463 8.39C5.748 6.403 7.11 4.644 7.11 4.644c.007-.005.894-.646 2.318-1.142.83-.292 1.675-.478 2.518-.557a9.68 9.68 0 0 1 2.05.03l2.97 2.97zM2.07 16.63a11.09 11.09 0 0 1-.334-1.865c-.08-.875-.055-1.744.076-2.576.1-.64.26-1.26.48-1.855.865-.73 2.01-1.158 2.642-1.355l4.16 4.296-.436 4.708-3.915 1.283c-1.034-.76-2.03-1.695-2.674-2.638zm20.236-.87c-.015.026-.077.062-.092.094l-4.296.392-2.37-4.144 2.144-5.847 3.025.19a10.72 10.72 0 0 1 1.696 1.784 9.59 9.59 0 0 1 1.395 2.643c-.336 2.92-1.17 4.38-1.502 4.887z"
                    />
                  </svg>
                  Soccer
                </Link>
              </div>
              <div>
                <img
                  src="data:image/gif;base64,R0lGODdhAQABAIAAAAAAAP///yH5BAEAAAEALAAAAAABAAEAAAICTAEAOw=="
                  alt=""
                />
                <Link
                  to={"/tennis"}
                  className={`px-2 py-1 rounded-lg flex ${
                    activeLink === 3 ? "change_color" : "Before_change_color"
                  }`}
                  onClick={() => changeColor(3)}
                  // className="bg-black relative px-[5px] py-[10px] rounded-[5px] text-[#ffb200] flex"
                >
                  <div className="live_headtitle top-[0px]">
                    <div className="bg-white h-full flex items-center justify-center w-[20px]">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="14"
                        height="8"
                      >
                        <g fill="rgb(255,0,0)" fill-rule="evenodd">
                          <path d="M12.012 0l-.698.727c1.734 1.808 1.734 4.738 0 6.546l.698.727c2.117-2.207 2.117-5.79 0-8zM10.3 1.714l-.7.735c.967 1.014.967 2.66 0 3.673l.7.735c1.352-1.418 1.352-3.721 0-5.143zM1.588 0l.698.727c-1.734 1.808-1.734 4.738 0 6.546L1.588 8c-2.117-2.207-2.117-5.79 0-8zM3.3 1.714l.7.735c-.967 1.014-.967 2.66 0 3.673l-.7.735c-1.352-1.418-1.352-3.721 0-5.143z" />
                          <circle cx="6.8" cy="4.4" r="1.6" />
                        </g>
                      </svg>
                    </div>

                    <span className=" text-[11px]  ">11</span>
                  </div>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="25"
                    height="25"
                  >
                    <path
                      fill="#ffb200"
                      d="M11.327.048c.358 3.07 1.93 6.34 4.608 9.02 2.68 2.68 5.95 4.25 9.015 4.606a12.44 12.44 0 0 1-3.605 7.674 12.453 12.453 0 0 1-7.676 3.607c-.354-3.07-1.926-6.336-4.607-9.017-2.68-2.68-5.946-4.25-9.017-4.607.26-2.8 1.463-5.53 3.608-7.673A12.479 12.479 0 0 1 11.327.047zM25 12.123c-2.687-.346-5.57-1.77-7.96-4.16C14.65 5.57 13.223 2.684 12.877 0a12.47 12.47 0 0 1 8.47 3.655A12.452 12.452 0 0 1 25 12.123zM0 12.88c2.684.35 5.57 1.773 7.958 4.163 2.392 2.39 3.816 5.275 4.162 7.957a12.454 12.454 0 0 1-8.466-3.652A12.452 12.452 0 0 1 0 12.88z"
                    />
                  </svg>
                  Tennis
                </Link>
              </div>
            </div>

            {[1, 2, 3, 4, 5, 6].map((ele) => {
              return (
                <div className="main_table_data bg-white  mt-[2px] flex">
                  <div className="game_list_col_left w-[50%] ">
                    <div className="event_info justify-between flex mt-1 mb-1 items-center">
                      <div className="flex items-center">
                        <img
                          className="w-[10px] bg-[#5ee02f] rounded-lg h-[10px] mx-2 "
                          src="data:image/gif;base64,R0lGODdhAQABAIAAAAAAAP///yH5BAEAAAEALAAAAAABAAEAAAICTAEAOw=="
                          alt=""
                        />
                        <Link
                          onClick={() =>
                            dispatch(
                              handelActiveMatch({
                                activeMatch: ele,
                                eventApiAddress: ele?.eid
                                  ? ele?.eid
                                  : ele?.etid,
                              })
                            )
                          }
                          to={{
                            pathname: `/game-list/event/${
                              ele?.eid ? ele?.eid : ele?.etid
                            }/${ele?.gameId ? ele?.gameId : ele?.gmid}`,
                          }}
                          className="text-[#2789ce] text-sm font-bold hover:underline"
                        >
                          {/*  {ele?.eventName?.split("/")[0]}
                      {ele?.ename}*/}
                          India vs Pakistan
                        </Link>
                      </div>
                      <div className="">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="25"
                          height="25"
                        >
                          <path
                            fill="#7E97A7"
                            d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                          />
                        </svg>
                      </div>
                    </div>
                    <div className="mx-4 items-center flex">
                      <span className="game-list-time">
                        <span className="text-sm">
                          {/* {ele?.eventName?.slice(0, -5).split("/")[1]}
                          {ele?.stime} */}
                        </span>
                      </span>
                      <span className="icons  font-bold">
                        <img
                          src="./img/ICONS/20230511_201058_0003 (1).png"
                          className="w-[20px] mr-2 rounded-sm  h-[20px]"
                          alt=""
                        />
                      </span>
                      <span className="icons text-[#508d0e] font-bold">
                        InPlay
                      </span>
                      <span className="icons">
                        <img
                          src="./img/ICONS/Video_Icon.png"
                          className="w-[20px] ml-2 h-[20px]"
                          alt=""
                        />
                      </span>
                    </div>
                  </div>
                  <div className="back_lay  hide_part_mobile pr-2 w-[50%] ">
                    <div className="back_lay_inne  mt-2 items-center justify-center gap-[5px] flex">
                      <span className="text-sm">PTED</span>
                      <div className="bg-[#72bbef]  py-[15px] font-semibold w-[66px] text-center">
                        <a href="">
                          {/* {ele?.back1
                            ? ele?.back1
                            : Array.isArray(ele?.market_runner_json)
                            ? ele?.market_runner_json[0]?.back[0]?.price
                            : ele?.section?.[0]?.odds
                            ? ele?.section[0]?.odds[0].otype === "back"
                              ? ele?.section[0]?.odds[0]?.odds
                              : ele?.section[0]?.odds[1].otype === "back"
                              ? ele?.section[0]?.odds[1].odds
                              : "0"
                            : "0"} */}
                        </a>
                      </div>
                      <div className="bg-[#faa9ba]  font-semibold py-[15px] w-[66px] text-center">
                        <a href="">
                          {/* {" "}
                          {ele?.lay1
                            ? ele?.lay1
                            : Array.isArray(ele?.market_runner_json)
                            ? ele?.market_runner_json[0]?.lay[0]?.price
                            : ele?.section?.[0]?.odds
                            ? ele?.section[0]?.odds[0].otype === "lay"
                              ? ele?.section[0]?.odds[0]?.odds
                              : ele?.section[0]?.odds[1].otype === "lay"
                              ? ele?.section[0]?.odds[1].odds
                              : "0"
                            : "0"} */}
                        </a>
                      </div>
                      <div className="bg-[#72bbef] w-[66px] font-semibold py-[15px] text-center">
                        <a href="">
                          {/* {" "}
                          {ele?.back11
                            ? ele?.back11
                            : Array.isArray(ele?.market_runner_json)
                            ? ele?.market_runner_json[0]?.back[1]?.price
                            : ele?.section?.[1]?.odds
                            ? ele?.section[1]?.odds[0].otype === "back"
                              ? ele?.section[1]?.odds[0]?.odds
                              : ele?.section[1]?.odds[1].otype === "back"
                              ? ele?.section[1]?.odds[1].odds
                              : "0"
                            : "0"} */}
                        </a>
                      </div>
                      <div className="bg-[#faa9ba] w-[66px] font-semibold py-[15px] text-center">
                        <a href="">
                          {/* {ele?.lay11
                            ? ele?.lay11
                            : Array.isArray(ele?.market_runner_json)
                            ? ele?.market_runner_json[0]?.lay[1]?.price
                            : ele?.section?.[1]?.odds
                            ? ele?.section[1]?.odds[0].otype === "lay"
                              ? ele?.section[1]?.odds[0]?.odds
                              : ele?.section[1]?.odds[1].otype === "lay"
                              ? ele?.section[1]?.odds[1].odds
                              : "0"
                            : "0"} */}
                        </a>
                      </div>
                      <div className="bg-[#72bbef] w-[66px] font-semibold py-[15px] text-center">
                        <a href="">
                          {/* {" "}
                          {ele?.back12
                            ? ele?.back12
                            : Array.isArray(ele?.market_runner_json)
                            ? ele?.market_runner_json[0]?.back[2]?.price
                            : ele?.section?.[2]?.odds
                            ? ele?.section[2]?.odds[0].otype === "back"
                              ? ele?.section[2]?.odds[0]?.odds
                              : ele?.section[2]?.odds[1].otype === "back"
                              ? ele?.section[2]?.odds[1].odds
                              : "0"
                            : "0"} */}
                        </a>
                      </div>
                      <div className="bg-[#faa9ba] w-[66px] font-semibold py-[15px] text-center">
                        <a href="">
                          {/* {" "}
                          {ele?.back12
                            ? ele?.back12
                            : Array.isArray(ele?.market_runner_json)
                            ? ele?.market_runner_json[0]?.lay[2]?.price
                            : ele?.section?.[2]?.odds
                            ? ele?.section[2]?.odds[0].otype === "lay"
                              ? ele?.section[2]?.odds[0]?.odds
                              : ele?.section[2]?.odds[1].otype === "lay"
                              ? ele?.section[2]?.odds[1].odds
                              : "0"
                            : "0"} */}
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
          {/* <BetSlip /> */}
        </div>
      </div>
      <MobFooter />
    </div>
  );
};

export default CricketPage;
